import { useAuth } from '../lib/auth';

const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || 'https://unplug-app.com';

export function WorkspaceNotFoundPage() {
  const { workspaceSlug, redirectToMarketing } = useAuth();

  return (
    <div class="error-page">
      <div class="error-card">
        <div class="error-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4m0 4h.01" />
          </svg>
        </div>

        <h1 class="error-title">Workspace Not Found</h1>

        <p class="error-message">
          The workspace <strong>{workspaceSlug}</strong> doesn't exist or has been deleted.
        </p>

        <div class="error-actions">
          <a href={MARKETING_URL} class="btn btn-primary">
            Go to Unplug Home
          </a>
          <a href={`${MARKETING_URL}/install`} class="btn btn-secondary">
            Add to Slack
          </a>
        </div>

        <p class="error-help">
          If you believe this is an error, please contact your workspace administrator
          or <a href={`${MARKETING_URL}/support`}>reach out to support</a>.
        </p>
      </div>

      <style>{`
        .error-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--gray-50);
          padding: 1rem;
        }

        .error-card {
          background: white;
          border-radius: 1rem;
          padding: 3rem;
          max-width: 480px;
          width: 100%;
          text-align: center;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .error-icon {
          color: var(--red-500);
          margin-bottom: 1.5rem;
        }

        .error-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: var(--gray-900);
          margin-bottom: 1rem;
        }

        .error-message {
          color: var(--gray-600);
          margin-bottom: 2rem;
          line-height: 1.6;
        }

        .error-message strong {
          color: var(--gray-900);
          font-family: monospace;
          background: var(--gray-100);
          padding: 0.125rem 0.5rem;
          border-radius: 0.25rem;
        }

        .error-actions {
          display: flex;
          gap: 1rem;
          justify-content: center;
          margin-bottom: 2rem;
        }

        .error-help {
          font-size: 0.875rem;
          color: var(--gray-500);
        }

        .error-help a {
          color: var(--primary-600);
        }
      `}</style>
    </div>
  );
}
